<template>
  <CallDialog
    v-model="show"
    :title="callStore.incomingCallAccepted ? 'Call in progress' : 'Someone is calling you'"
    :contact="callStore.incomingCallContact"
    :show-duration="callStore.incomingCallAccepted"
    @close="callStore.endIncomingCall()"
  >
    <template #buttons>
      <CallButtons
        v-if="callStore.incomingCallAccepted"
        :muted="callStore.incomingCallMuted"
        @end-call="callStore.endIncomingCall()"
        @toggle-mute="callStore.toggleMuteIncomingCall()"
      />
      <div v-else class="width-100 d-flex justify-space-between align-center">
        <EmIconButton
          icon="mdi-phone-hangup"
          size="large"
          color="white"
          button-class="bg-error"
          @click="callStore.endIncomingCall()"
        />
        <EmIconButton
          icon="mdi-phone"
          size="large"
          color="white"
          button-class="bg-success"
          @click="callStore.acceptIncomingCall()"
        />
      </div>
    </template>
  </CallDialog>
</template>

<script setup>
const callStore = useCallStore()
const show = computed(() => !!callStore.incomingCall)
</script>
